//Assign custom thumbnail images (4 icons displayed below hero image on product page, based on model AND color) | SortinoSoft
(function() {
  'use strict';
  
  // Configuration: Map model + color to arrays of custom images
  // Each array can have up to 4 images (positions 0-3 for thumbnails 1-4)
  // Set array position to null to use the default image for that thumbnail
  if (isOctoPage()) {
    console.log('Page type Ocoto');
    var customImages = {
      'iPhone 17': {
        'Black/Black': ['octopouch-iphone-17-black-black-1.jpg', null, null, 'octopouch-iphone-17-black-black-4.jpg'],
        'Black/Clear': ['octopouch-iphone-17-black-clear-1.jpg', null, null, 'octopouch-iphone-17-black-clear-4.jpg'],
        'Lavender/Lavender': ['octopouch-iphone-17-lavender-lavender-1.jpg', null, null, 'octopouch-iphone-17-lavender-lavender-4.jpg'],
        'Lavender/Clear': ['octopouch-iphone-17-lavender-clear-1.jpg', null, null, 'octopouch-iphone-17-lavender-clear-4.jpg'],
        'Baby Blue/Baby Blue': ['octopouch-iphone-17-blue-blue-1.jpg', null, null, 'octopouch-iphone-17-blue-blue-4.jpg'],
        'Baby Blue/Clear': ['octopouch-iphone-17-blue-clear-1.jpg', null, null, 'octopouch-iphone-17-blue-clear-4.jpg'],
        'Mocha/Mocha': ['octopouch-iphone-17-mocha-mocha-1.jpg', null, null, 'octopouch-iphone-17-mocha-mocha-4.jpg'],
        'Mocha/Clear': ['octopouch-iphone-17-mocha-clear-1.jpg', null, null, 'octopouch-iphone-17-mocha-clear-4.jpg'],
        'Matcha/Matcha': ['octopouch-iphone-17-matcha-matcha-1.jpg', null, null, 'octopouch-iphone-17-matcha-matcha-4.jpg'],
        'Matcha/Clear': ['octopouch-iphone-17-matcha-clear-1.jpg', null, null, 'octopouch-iphone-17-matcha-clear-4.jpg'],
        // ---- NEW PINK COLORS ----
        'Pink/Bubble Gum': ['octopouch-iphone-17-pink-bubblegum-1.jpg', null, null, 'octopouch-iphone-17-pink-bubblegum-4.jpg'],
        'Pink/Clear': ['octopouch-iphone-17-pink-clear-1.jpg', null, null, 'octopouch-iphone-17-pink-clear-4.jpg']
        // -------------------------
      },
      'iPhone 17 Air': {
        'Black/Black': ['octopouch-iphone-air-black-black-1.jpg', null, null, 'octopouch-iphone-17-air-black-black-4.jpg'],
        'Black/Clear': ['octopouch-iphone-17-air-black-clear-1.jpg', null, null, 'octopouch-iphone-17-air-black-clear-4.jpg'],
        'Lavender/Lavender': ['octopouch-iphone-17-air-lavender-lavender-1.jpg', null, null, 'octopouch-iphone-17-air-lavender-lavender-4.jpg'],
        'Lavender/Clear': ['octopouch-iphone-17-air-lavender-clear-1.jpg', null, null, 'octopouch-iphone-17-air-lavender-clear-4.jpg'],
        'Baby Blue/Baby Blue': ['octopouch-iphone-17-air-blue-blue-1.jpg', null, null, 'octopouch-iphone-17-air-blue-blue-4.jpg'],
        'Baby Blue/Clear': ['octopouch-iphone-17-air-blue-clear-1.jpg', null, null, 'octopouch-iphone-17-air-blue-clear-4.jpg'],
        'Mocha/Mocha': ['octopouch-iphone-17-air-mocha-mocha-1.jpg', null, null, 'octopouch-iphone-17-air-mocha-mocha-4.jpg'],
        'Mocha/Clear': ['octopouch-iphone-17-air-mocha-clear-1.jpg', null, null, 'octopouch-iphone-17-air-mocha-clear-4.jpg'],
        'Matcha/Matcha': ['octopouch-iphone-17-air-matcha-matcha-1.jpg', null, null, 'octopouch-iphone-17-air-matcha-matcha-4.jpg'],
        'Matcha/Clear': ['octopouch-iphone-17-air-matcha-clear-1.jpg', null, null, 'octopouch-iphone-17-air-matcha-clear-4.jpg'],
        // ---- NEW PINK COLORS ----
        'Pink/Bubble Gum': ['octopouch-iphone-17-air-pink-bubblegum-1.jpg', null, null, 'octopouch-iphone-17-air-pink-bubblegum-4.jpg'],
        'Pink/Clear': ['octopouch-iphone-17-air-pink-clear-1.jpg', null, null, 'octopouch-iphone-17-air-pink-clear-4.jpg']
        // -------------------------
      }
    };  
  } else {
    console.log('Page type Flex');
    var customImages = {
      'iPhone 17': {
        'Black/Black': ['iphone-17-black-black-1.jpg', null, null, 'iphone-17-black-black-4.jpg'],
        'Black/Clear': ['iphone-17-black-clear-1.jpg', null, null, 'iphone-17-black-clear-4.jpg'],
        'Lavender/Lavender': ['iphone-17-lavender-lavender-1.jpg', null, null, 'iphone-17-lavender-lavender-4.jpg'],
        'Lavender/Clear': ['iphone-17-lavender-clear-1.jpg', null, null, 'iphone-17-lavender-clear-4.jpg'],
        'Baby Blue/Baby Blue': ['iphone-17-blue-blue-1.jpg', null, null, 'iphone-17-blue-blue-4.jpg'],
        'Baby Blue/Clear': ['iphone-17-blue-clear-1.jpg', null, null, 'iphone-17-blue-clear-4.jpg'],
        'Mocha/Mocha': ['iphone-17-mocha-mocha-1.jpg', null, null, 'iphone-17-mocha-mocha-4.jpg'],
        'Mocha/Clear': ['iphone-17-mocha-clear-1.jpg', null, null, 'iphone-17-mocha-clear-4.jpg'],
        'Matcha/Matcha': ['iphone-17-matcha-matcha-1.jpg', null, null, 'iphone-17-matcha-matcha-4.jpg'],
        'Matcha/Clear': ['iphone-17-matcha-clear-1.jpg', null, null, 'iphone-17-matcha-clear-4.jpg'],
        // ---- NEW PINK COLORS ----
        'Pink/Bubble Gum': ['iphone-17-pink-bubblegum-1.jpg', null, null, 'iphone-17-pink-bubblegum-4.jpg'],
        'Pink/Princess Sparkles': ['iphone-17-pink-princesssparkles-1.jpg', null, null, 'iphone-17-pink-princesssparkles-4.jpg']
        // -------------------------
      },
      'iPhone 17 Air': {
        'Black/Black': ['iphone-17-air-black-black-1.jpg', null, null, 'iphone-17-air-black-black-4.jpg'],
        'Black/Clear': ['iphone-17-air-black-clear-1.jpg', null, null, 'iphone-17-air-black-clear-4.jpg'],
        'Lavender/Lavender': ['iphone-17-air-lavender-lavender-1.jpg', null, null, 'iphone-17-air-lavender-lavender-4.jpg'],
        'Lavender/Clear': ['iphone-17-air-lavender-clear-1.jpg', null, null, 'iphone-17-air-lavender-clear-4.jpg'],
        'Baby Blue/Baby Blue': ['iphone-17-air-blue-blue-1.jpg', null, null, 'iphone-17-air-blue-blue-4.jpg'],
        'Baby Blue/Clear': ['iphone-17-air-blue-clear-1.jpg', null, null, 'iphone-17-air-blue-clear-4.jpg'],
        'Mocha/Mocha': ['iphone-17-air-mocha-mocha-1.jpg', null, null, 'iphone-17-air-mocha-mocha-4.jpg'],
        'Mocha/Clear': ['iphone-17-air-mocha-clear-1.jpg', null, null, 'iphone-17-air-mocha-clear-4.jpg'],
        'Matcha/Matcha': ['iphone-17-air-matcha-matcha-1.jpg', null, null, 'iphone-17-air-matcha-matcha-4.jpg'],
        'Matcha/Clear': ['iphone-17-air-matcha-clear-1.jpg', null, null, 'iphone-17-air-matcha-clear-4.jpg'],
        // ---- NEW PINK COLORS ----
        'Pink/Bubble Gum': ['iphone-17-air-pink-bubblegum-1.jpg', null, null, 'iphone-17-air-pink-bubblegum-4.jpg'],
        'Pink/Princess Sparkles': ['iphone-17-air-pink-princesssparkles-1.jpg', null, null, 'iphone-17-air-pink-princesssparkles-4.jpg']
        // -------------------------
      }
    };
  }
  
  // Base CDN path (update this to your actual path)
  const cdnBasePath = '//ninjalabs.com/cdn/shop/files/';
  
  // Store which thumbnails have been customized (so we know which to restore)
  let customizedThumbnails = new Set();
  
  // Track if we're currently using custom images
  let currentlyUsingCustomImages = false;
  
  // Debug mode - set to true to see console logs
  const DEBUG = false;
  
  function log(...args) {
    if (DEBUG) console.log('[CustomImages]', ...args);
  }
  
  // Get current selections
  function getCurrentColor() {
    const checkedInput = document.querySelector('input[name="options[' + colorLang + ']"]:checked');
    console.log(checkedInput.value);
    console.log(colorTranslations[checkedInput.value]);
    return checkedInput ? colorTranslations[checkedInput.value] : null;
  }
  
  function getCurrentModel() {
    const modelInput = document.querySelector('input[data-input="model"]');
    return modelInput ? modelInput.value : null;
  }
  
  // Check if current model should use custom images
  function shouldUseCustomImage() {
    const model = getCurrentModel();
    const should = model && customImages.hasOwnProperty(model);
    console.log('shouldUseCustomImage?', should, '(model:', model, ')');
    return should;
  }
  
  // Get custom images array for current model + color
  function getCustomImagesArray() {
    const model = getCurrentModel();
    const color = getCurrentColor();
    
    console.log("url=" + customImages[model][color]);
    if (!model || !color || !customImages[model] || !customImages[model][color]) {
      return null;
    }
    
    return customImages[model][color];
  }
  
  // Get all thumbnail image elements
  function getAllThumbnails() {
    return document.querySelectorAll('.product-single__thumbnail-img');
  }
  
  // Get specific thumbnail by index (0-based)
  function getThumbnail(index) {
    const thumbnails = getAllThumbnails();
    return thumbnails[index] || null;
  }
  
  // Get ALL hero images (one for each thumbnail)
  function getAllHeroImages() {
    return document.querySelectorAll('[data-product-image]');
  }
  
  // Get specific hero image by index (0-based)
  function getHeroImage(index) {
    const heroImages = getAllHeroImages();
    return heroImages[index] || null;
  }
  
  // Generate srcset for an image
  function generateSrcset(baseUrl, widths) {
    return widths.map(width => {
      return `${baseUrl}?v=1757984572&width=${width} ${width}w`;
    }).join(', ');
  }
  
  // Update a specific thumbnail with custom image
  function updateThumbnailWithCustom(index, customFileName) {
    const thumbnail = getThumbnail(index);
    if (!thumbnail) return;
    
    const color = getCurrentColor();
    const model = getCurrentModel();
    
    log('Updating thumbnail', index, 'with custom image:', customFileName);
    const customImageUrl = cdnBasePath + customFileName;
    
    // Widths for thumbnail srcset
    const thumbnailWidths = [90, 180, 1200];
    const thumbnailSrcset = generateSrcset(customImageUrl, thumbnailWidths);
    
    thumbnail.src = customImageUrl;
    thumbnail.setAttribute('data-src', customImageUrl);
    thumbnail.srcset = thumbnailSrcset;
    thumbnail.setAttribute('data-srcset', thumbnailSrcset);
    thumbnail.alt = color + ' - ' + model;
    
    // Mark this thumbnail as customized
    customizedThumbnails.add(index);
  }
  
  // Update specific hero image with custom image
  function updateHeroImageWithCustom(index, customFileName) {
    const heroImage = getHeroImage(index);
    if (!heroImage) {
      log('Could not find hero image at index', index);
      return;
    }
    
    const color = getCurrentColor();
    const model = getCurrentModel();
    
    log('Updating hero image', index, 'with custom:', customFileName);
    const customImageUrl = cdnBasePath + customFileName;
    
    // Widths for hero image srcset
    const heroWidths = [245, 320, 365, 410, 490, 640, 753, 848, 980, 1024, 1200];
    const heroSrcset = generateSrcset(customImageUrl, heroWidths);
    
    heroImage.src = customImageUrl + '?crop=center&height=1200&v=1757984572&width=1200';
    heroImage.setAttribute('data-src', customImageUrl + '?crop=center&height=1200&v=1757984572&width=1200');
    heroImage.srcset = heroSrcset;
    heroImage.setAttribute('data-srcset', heroSrcset);
    heroImage.alt = color + ' - ' + model;
  }
  
  // Trigger Shopify to reload images for current color
  function triggerShopifyImageUpdate() {
    log('Triggering Shopify image update');
    
    const colorInput = document.querySelector('input[name="options[' + colorLang + ']"]:checked');
    if (!colorInput) return;
    
    // Trigger a change event to make Shopify reload images
    const event = new Event('change', { bubbles: true });
    colorInput.dispatchEvent(event);
  }
  
  // Update all images based on current selections
  function updateImages() {
    const color = getCurrentColor();
    const model = getCurrentModel();
    const useCustom = shouldUseCustomImage();
    
    log('updateImages called - Color:', color, 'Model:', model, 'UseCustom:', useCustom);
    
    if (useCustom) {
      const customImagesArray = getCustomImagesArray();
      
      if (customImagesArray && Array.isArray(customImagesArray)) {
        log('Using custom images array:', customImagesArray);
        currentlyUsingCustomImages = true;
        
        // Update each thumbnail position AND its corresponding hero image
        for (let i = 0; i < customImagesArray.length; i++) {
          const customFileName = customImagesArray[i];
          
          if (customFileName) {
            // Use custom image for this thumbnail and hero
            updateThumbnailWithCustom(i, customFileName);
            updateHeroImageWithCustom(i, customFileName);
          }
        }
        
      } else {
        log('No custom images found for', model, color);
        currentlyUsingCustomImages = false;
      }
      
    } else {
      // Switching to non-custom model (Pro/Pro Max)
      if (currentlyUsingCustomImages) {
        log('Switching from custom to default model');
        
        // Clear the customized thumbnails set
        customizedThumbnails.clear();
        currentlyUsingCustomImages = false;
        
        // Let Shopify update all images by triggering a color change
        triggerShopifyImageUpdate();
        
      } else {
        log('Non-custom model, letting Shopify handle everything');
        // Do nothing - let Shopify's code work normally
      }
    }
  }
  
  // Listen for color swatch changes
  function attachColorListeners() {
    const colorInputs = document.querySelectorAll('input[name="options[' + colorLang + ']"]');
    colorInputs.forEach(input => {
      input.addEventListener('change', function() {
        log('Color changed to:', this.value);
        
        // When color changes on non-custom model, just clear our tracking
        if (!shouldUseCustomImage()) {
          customizedThumbnails.clear();
        }
        
        // Add delay to run AFTER Shopify's built-in image swap
        setTimeout(() => {
          updateImages();
        }, 50);
      });
    });
  }
  
  // Listen for model dropdown changes
  function attachModelListeners() {
    // Listen to the custom dropdown options
    const modelOptions = document.querySelectorAll('[data-popout-option]');
    modelOptions.forEach(option => {
      option.addEventListener('click', function(e) {
        log('Model option clicked:', this.getAttribute('data-value'));
        
        // Clear customized thumbnails tracking
        customizedThumbnails.clear();
        
        // Small delay to let the hidden input update and Shopify to update images
        setTimeout(() => {
          updateImages();
        }, 250);
      });
    });
    
    // Also listen to the hidden input directly (belt and suspenders approach)
    const modelInput = document.querySelector('input[data-input="model"]');
    if (modelInput) {
      // Use MutationObserver to watch for value changes
      const observer = new MutationObserver(() => {
        log('Model input changed via mutation observer');
        
        // Clear customized thumbnails tracking
        customizedThumbnails.clear();
        
        setTimeout(() => {
          updateImages();
        }, 250);
      });
      
      observer.observe(modelInput, {
        attributes: true,
        attributeFilter: ['value']
      });
    }
  }
  
  // Initialize on page load
  function initSwap() {
    // Wait for DOM to be fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }
    
    log('Initializing custom images script');
    
    // Update images based on initial state
    updateImages();
    
    // Attach event listeners
    attachColorListeners();
    attachModelListeners();
    
    log('Initialization complete');
  }
  
  initSwap();
  
})();
